import { EBrandIconIconPathShared } from 'src/libraryShared/icons';

export enum EWheelBundleImages {
  JACKPOT = `wheel-jackpot.png`,
  CASHBACK = `wheel-cashback.png`,
  SUPER_FREE_SPINS = `wheel-sfs.png`,
  MEGA_SPINS = `wheel-mspins.png`,
  GAME = `wheel-game.png`,
  REAL_MONEY = `wheel-rmoney.png`,
  FREE_SPINS = `wheel-fspins.png`,
}
export enum EWheelImages {
  JACKPOT = `jackpot`,
  CASHBACK = `cashback`,
  SUPER_FREE_SPINS = `sfs`,
  MEGA_SPINS = `mspins`,
  GAME = `game`,
  REAL_MONEY = `rmoney`,
  FREE_SPINS = `fspins`,
}
export interface IWheelPrizeData {
  /** Box shadow on win screen */
  color: string;
  /** Name of prize */
  name: string;
  /** The name of image inside the wheel project */
  image: EWheelImages;
  /** Description of prize */
  description: string;
  /**using in the win screen layout */
  icon: EBrandIconIconPathShared;
  /**using for description popup */
  iconSecondary: EBrandIconIconPathShared;
}
export type TWheelPrizeDataMap = {
  [K in EWheelBundleImages]: IWheelPrizeData;
};
export const WHEEL_PRIZE_DATA: TWheelPrizeDataMap = {
  [EWheelBundleImages.GAME]: {
    color: `#AF56FF`,
    name: `wheel.page.popup.title.bonus.game`,
    /** BE name */
    image: EWheelImages.GAME,
    description: `wheel.page.popup.description.bonus.game`,
    icon: EBrandIconIconPathShared.WheelGame,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryGame,
  },
  [EWheelBundleImages.CASHBACK]: {
    color: `#00FE42`,
    name: `wheel.page.popup.title.bonus.money`,
    image: EWheelImages.CASHBACK,
    description: `wheel.page.popup.description.bonus.money`,
    icon: EBrandIconIconPathShared.WheelCashback,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryCashback,
  },
  [EWheelBundleImages.SUPER_FREE_SPINS]: {
    color: `#FE901A`,
    name: `wheel.page.popup.title.super.spins`,
    image: EWheelImages.SUPER_FREE_SPINS,
    description: `wheel.page.popup.description.super.spins`,
    icon: EBrandIconIconPathShared.WheelSfs,
    iconSecondary: EBrandIconIconPathShared.WheelSecondarySfs,
  },
  [EWheelBundleImages.MEGA_SPINS]: {
    color: `#DE6EFF`,
    name: `wheel.page.popup.title.mega.spins`,
    image: EWheelImages.MEGA_SPINS,
    description: `wheel.page.popup.description.mega.spins`,
    icon: EBrandIconIconPathShared.WheelMspins,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryMspins,
  },
  [EWheelBundleImages.JACKPOT]: {
    color: `#FE901A`,
    name: `wheel.page.popup.title.jackpot`,
    image: EWheelImages.JACKPOT,
    description: `wheel.page.popup.description.jackpot`,
    icon: EBrandIconIconPathShared.WheelJackpot,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryJackpot,
  },
  [EWheelBundleImages.FREE_SPINS]: {
    color: `#3EE9FB`,
    name: `wheel.page.popup.title.fspins`,
    image: EWheelImages.FREE_SPINS,
    description: `wheel.page.popup.description.fspins`,
    icon: EBrandIconIconPathShared.WheelFspins,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryFspins,
  },
  [EWheelBundleImages.REAL_MONEY]: {
    color: `#FE901A`,
    name: `wheel.page.popup.title.rmoney`,
    image: EWheelImages.REAL_MONEY,
    description: `wheel.page.popup.description.rmoney`,
    icon: EBrandIconIconPathShared.WheelRmoney,
    iconSecondary: EBrandIconIconPathShared.WheelSecondaryRmoney,
  },
};
